import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
  selector: 'sd-pickup-active-shop-scheme-modal',
  templateUrl: './pickup-active-shop-scheme-modal.component.html',
  styleUrls: ['./pickup-active-shop-scheme-modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class SdvorPickupActiveShopSchemeModalComponent {
  @Input() scheme: string;
}
